import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OtpComponent } from '../components/otp/otp.component';

@Component({
  selector: 'app-otp-page',
  templateUrl: './otp-page.component.html',
  styleUrls: ['../verify-request/verify-request.component.css'],
  standalone: false
})
export class OtpPageComponent implements AfterViewInit {
  success = true;
  verified = false;
  otpValue: any;
  phoneNumber: string = '';
  token: string = '';
  skipSendSms: boolean = false;
  @ViewChild('otpComponent', { static: false }) otpComponent!: OtpComponent;

  otpConfig = {
    length: 5,
    autofocus: true,
    inputClass: 'otp-input-custom mb-4'
  };

  constructor(
    private activatedRoute: ActivatedRoute
  ) {
    const requestVerifyIdentityFromState = history.state?.requestVerifyIdentity;
    this.skipSendSms = requestVerifyIdentityFromState || false;

    if (requestVerifyIdentityFromState == true) {
      history.replaceState({}, '');
    }

    this.activatedRoute.queryParams.subscribe(params => {
      this.phoneNumber = params['phoneNumber'] || null;
      this.token = params['token'] || null;

    });
  }


  ngAfterViewInit() {
    if (!this.skipSendSms && this.otpComponent) {
      this.otpComponent.sendOtp();
    }
  }

}
